module.exports = __webpack_public_path__ + "media/src/public/img/text-card-image-cbee6bce145a2996fc48b65f92b1c748.jpg";